export default function (uku) {
    this.myName = "name from OtherCtrl";
}


//////////////////
// WEBPACK FOOTER
// ./resources/js/otherCtrl.js
// module id = 21
// module chunks = 0